'use client';

import dynamic from 'next/dynamic';

const MainScreen = dynamic(() => import('@/components/screens/MainScreen'), {
  ssr: false,
  loading: () => (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ background: '#030712' }}
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-14 h-14 rounded-full border-2 border-t-transparent animate-spin"
          style={{
            borderColor: 'rgba(148,180,240,0.4)',
            borderTopColor: 'rgba(148,180,240,0.9)',
          }}
        />
        <p
          className="text-sm font-light tracking-widest"
          style={{ color: 'rgba(148,180,240,0.6)' }}
        >
          世界漫游
        </p>
      </div>
    </div>
  ),
});

export default function ClientEntry() {
  return <MainScreen />;
}
